export default __webpack_public_path__ + "static/media/icon-union.6b13844d.svg";